module.exports = __webpack_public_path__ + "img/ivory_coast.554aab3.webp";